import { getUrl, Post, Get, Put, Patch } from '.'

export const List = async body => {
  return Post(getUrl('cnps.css.contact.search'), body)
}

export const Create = async body => {
  return Post(getUrl('cnps.css.contact.create'), body)
}

export const Detail = async id => {
  return Get(getUrl('cnps.css.contact.get', { id }))
}

export const Update = async (id, body) => {
  return Put(getUrl('cnps.css.contact.update', { id }), body)
}

export const UpdateStatus = async (id, body) => {
  return Patch(getUrl('cnps.css.contact.update-status', { id }), body)
}
